module.exports = __webpack_public_path__ + "img/6.f5108c83.jpg";